import { LandingNav } from "./landing/LandingNav";
import { LandingHero } from "./landing/LandingHero";
import { CaseStudyTeaser } from "./landing/CaseStudyTeaser";
import { Comparison } from "./landing/Comparison";
import { ScaleSection } from "./landing/ScaleSection";
import { CelebrateSection } from "./landing/CelebrateSection";
import { HowItWorks } from "./landing/HowItWorks";
import { NotDIYSection } from "./landing/NotDIYSection";
import { CTAForm } from "./landing/CTAForm";
import { MoreUseCases } from "./use-cases/MoreUseCases";
import { LandingFooter } from "./landing/LandingFooter";

export const LandingPage = () => (
  <div className="bg-fwd-white text-fwd-ink font-sans overflow-x-hidden">
    <LandingNav />
    <LandingHero />
    <CaseStudyTeaser />
    <Comparison />
    <ScaleSection />
    <CelebrateSection />
    <HowItWorks />
    <NotDIYSection />
    <MoreUseCases headline="Ways teams use Forward" />
    <CTAForm />
    <LandingFooter />
  </div>
);
